var _rect, _rect2, _rect3, _rect4, _circle, _rect5, _path, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 100,
    fill: "#F0F3F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-780 -414)",
    fill: "#F5F6F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -716,
    y: -260,
    width: 1311,
    height: 804,
    rx: 8,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -72.5,
    y: -58.5,
    width: 246,
    height: 313,
    rx: 7.5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#F5F7FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -72.5,
    y: -58.5,
    width: 246,
    height: 313,
    rx: 7.5,
    stroke: "#A7AABD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3337 33.3333H43.0003C42.1163 33.3333 41.2684 33.6844 40.6433 34.3096C40.0182 34.9347 39.667 35.7825 39.667 36.6666V63.3333C39.667 64.2173 40.0182 65.0652 40.6433 65.6903C41.2684 66.3154 42.1163 66.6666 43.0003 66.6666H63.0003C63.8844 66.6666 64.7322 66.3154 65.3573 65.6903C65.9825 65.0652 66.3337 64.2173 66.3337 63.3333V43.3333M56.3337 33.3333L66.3337 43.3333M56.3337 33.3333V43.3333H66.3337M59.667 51.6666H46.3337M59.667 58.3333H46.3337M49.667 44.9999H46.3337",
    stroke: "#2B5297",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -20913,
    y: -33653,
    width: 53660,
    height: 41487,
    stroke: "black",
    strokeWidth: 50
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicInvoices);
export default __webpack_public_path__ + "static/media/topic-invoices.d122a114fd21e3f451decb11ae9b5486.svg";
export { ForwardRef as ReactComponent };